import { Link } from 'react-router-dom';

const rows = [
  {
    id: 'exc-c-04',
    type: 'Evidence mismatch',
    asset: 'A-18721',
    stage: 'Admission',
    sla: '24h',
  },
  {
    id: 'exc-c-02',
    type: 'State conflict',
    asset: 'A-18697',
    stage: 'Release vs pledge',
    sla: '8h',
  },
  {
    id: 'exc-c-01',
    type: 'Clarification — provider',
    asset: 'A-18788',
    stage: 'Pledge',
    sla: '48h',
  },
];

export function CustodianExceptionsPage() {
  return (
    <div className="page-stack">
      <section className="card-shell p-5 sm:p-6">
        <p className="text-sm leading-relaxed text-evault-muted">
          Custody-side clarification blockers and mismatches — distinct from
          provider packaging exceptions.
        </p>
      </section>

      <div className="table-shell overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] border-collapse text-left text-xs sm:text-sm">
            <thead>
              <tr className="border-b border-evault-border bg-evault-surface/90">
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  ID
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Type
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Asset
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Stage
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  SLA
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, ri) => (
                <tr
                  key={row.id}
                  className={`border-b border-evault-border last:border-b-0 ${
                    ri % 2 === 1 ? 'bg-evault-surface/40' : ''
                  }`}
                >
                  <td className="px-4 py-3.5 font-medium">
                    <Link
                      to={`/custodian/exceptions/${row.id}`}
                      className="text-evault-teal hover:underline"
                    >
                      {row.id}
                    </Link>
                  </td>
                  <td className="px-4 py-3.5 text-umb-neutral-dark/90">
                    {row.type}
                  </td>
                  <td className="px-4 py-3.5 font-mono text-[11px] sm:text-xs">
                    <Link
                      to={`/custodian/assets/${encodeURIComponent(row.asset)}`}
                      className="text-evault-teal hover:underline"
                    >
                      {row.asset}
                    </Link>
                  </td>
                  <td className="px-4 py-3.5 text-umb-neutral-dark/80">
                    {row.stage}
                  </td>
                  <td className="px-4 py-3.5 font-semibold text-evault-gold">
                    {row.sla}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
